import React from 'react';
import './App.css';
import Home from './Page/Home';

function App() { 

  return (
    <>
    <>
    <Home></Home>
    </>
      </>
  );
}

export default App;
